import { IFramePostMessageDataLocationValue } from '../types';
import { IFrameUrlState } from './iframe-url-state';

export class IFrameUpdater {
  constructor(
    private iframe: HTMLIFrameElement,
    private iframeUrlState: IFrameUrlState
  ) {}

  setHeight(value: number): void {
    this.iframe.style.height = `${value}px`;
  }

  setLocation(value: IFramePostMessageDataLocationValue): void {
    const isDifferentPathname = this.iframeUrlState.isDifferentPathname(value);

    this.iframeUrlState.setLocation(value);

    this.setReq();

    if (isDifferentPathname) {
      return this.scrollIntoView();
    }
  }

  private setReq() {
    const url = new URL(window.location.href);
    url.searchParams.set('req', encodeURIComponent(this.iframeUrlState.relativePath));

    window.history.replaceState(null, '', url.toString());
  }

  private scrollIntoView() {
    setTimeout(() => {
      this.iframe.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }
}
